<template>
  <!-- 试题选项--针对单选、多选、判断等题型、选词填空 -->
  <div>
    <!-- <div class="que_box" v-for="item in selectsArr" :key="item.orders"> -->
    <!-- 题干 -->
    <div>
      {{ item.orders }}、 <span v-html="item.titleHtml"></span> ({{
        item.score
      }}分)
    </div>
    <!-- 选项 -->
    <ul class="option_arr">
      <li v-for="option in item.selects" :key="option.orders">
        <i :class="subjectType != 4 ? 'option' : ''">{{ option.prefix }}</i>

        <span v-if="decodeURIComponent(option.contents).indexOf('http') === -1"
          v-html="decodeURIComponent(option.contents)"></span>
        <img v-else class="option_img" alt="试题选项" :src="decodeURIComponent(option.contents)" />
      </li>
    </ul>
    <!-- 答案 -->
    <ul class="ans_ul">
      <li :class="item.types == 5 ? 'block' : 'line'">
        正确答案：<span class="green_font">{{ item.correctAnswer }}</span>
      </li>
      <li :class="item.types == 5 ? 'block' : 'line'">
        考生作答：<span :class="item.correctAnswer == item.studentAnswer
          ? 'green_font'
          : 'red_font'
          ">{{ item.studentAnswer ? item.studentAnswer : "未作答" }}</span>
      </li>
    </ul>
    <!-- 教师评分： -->
    <ul class="teacher_score">
      <li>
        教师评分：
        <el-input style="width: 30%" type="number" v-model="item.teacherScore"
          @input="inputFunc(item.orders, item.teacherScore)">
        </el-input>
        分
      </li>
      <li>
        教师评语：
        <el-input style="width: 86%" type="text" placeholder="请输入本题评语（可以留空）" v-model="item.comment" maxlength="100"
          show-word-limit>
        </el-input>
      </li>
    </ul>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "SelectsType",
  props: {
    // selectsArr: Array,
    item: Object,
    subjectType: Number,
  },
  created() {
    // this.selectsArr.forEach((item) => {
    this.item.titleHtml = this.item.titleHtml.replace(
      /<img/g,
      "<img style='width:80px;height:auto;'"
    );
    // 选项数组
    if (this.item.selects) {
      //单选题
      if (this.subjectType == 1) {
        //  判断选项数组中的isSelect是否有不同，全部相同都是false说明考生没有选择答案
        if (
          this.item.selects.some(
            (e) => this.item.selects.filter((e1) => e1.isSelect != e.isSelect).length > 1
          )
        ) {
          // 有作答
          this.item.selects.forEach((option) => {
            if (option.isAnser) {
              this.item.correctAnswer = option.prefix;
            }
            if (option.isSelect) {
              this.item.studentAnswer = option.prefix;
            }
          });
        } else {
          // 没有作答
          this.item.selects.forEach((option) => {
            if (option.isAnser) {
              this.item.correctAnswer = option.prefix;
            }
            this.item.studentAnswer = null;
          });
        }
      }
      // 多选题
      if (this.subjectType == 2) {
        this.item.correctAnswer = "";
        this.item.studentAnswer = "";
        //部分选
        if (
          this.item.selects.some(
            (e) =>
              this.item.selects.filter((e1) => e1.isSelect != e.isSelect).length >
              1
          )
        ) {
          this.item.selects.forEach((option) => {
            if (option.isAnser) {
              this.item.correctAnswer += option.prefix + "";
            }
            if (option.isSelect) {
              this.item.studentAnswer += option.prefix + "";
            }
          });
        }
        // 全选
        if (
          this.item.selects.every(
            (val, i, arr) =>
              val.isSelect === arr[0].isSelect && val.isSelect === true
          )
        ) {
          this.item.selects.forEach((option) => {
            if (option.isAnser) {
              this.item.correctAnswer += option.prefix + "";
            }
            this.item.studentAnswer += option.prefix + "";
          });
        }
        //未选
        if (
          this.item.selects.every(
            (val, i, arr) =>
              val.isSelect === arr[0].isSelect && val.isSelect === false
          )
        ) {
          this.item.selects.forEach((option) => {
            if (option.isAnser) {
              this.item.correctAnswer = option.prefix;
            }
            this.item.studentAnswer = null;
          });
        }
      }
      // 判断题
      if (this.subjectType == 4) {
        this.item.selects.forEach((option) => {
          option.isAnser ? (this.item.correctAnswer = option.prefix) : null;
          // 未作答
          if (
            this.item.selects.every(
              (val, i, arr) => (val.isSelect === arr[0].isSelect) === false
            )
          ) {
            this.item.studentAnswer = null;
          } else {
            if (option.isSelect) {
              this.item.studentAnswer = option.prefix;
            }
          }
        });
      }
    }
    // });

  },
  watch: {
    selectsArr: {
      handler(newValue) {
        this.$emit("change-select", newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    inputFunc(index, val) {
      // 判断当前是哪个input输入框改变
      // this.selectsArr.map((item) => {
      if (this.item.orders == index) {
        if (val > this.item.score) {
          this.$alert(
            "亲:试题分数不能大于[试题满分]请重新评分！",
            "友情提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.item.teacherScore = 0;
              },
            }
          );
          return false;
        }
      }
      // });
    },
  },
};
</script>

<style scoped></style>